import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    _language: navigator.language,
    token: null,
    userName: null,
    userRole: null,
    companyId: null,
    expiration: 0,
    isAuthenticated: false,
    componentControls: {
      'BalanceNiif': {
        'Notas': true,
        'Balance': true,
        'Comparativo': true,
        'Consolidado': true,
        'Informacion': true
      },
    },
    periodos: {
      // Aquí se almacenarán las vigencias con su estado
      // Ejemplo: '202412': true, '202501': true
    }
    
  },
  mutations: {
    setData(state, val){
        state.token = val.token
        state.userName = val.username
        state.providerId = val.inscriptionId
        state.userRole = val.role
        const now = new Date();
        const expirationDate = new Date(now.getTime() + val.expiresIn * 1000);
        state.userId = val.id
        state.expiration = expirationDate
        state.isAuthenticated = val.isAuthenticated
        state.companyId = val.companyId
    },
    setLang(state, val){
        state._language = val
    },

    updateComponentControl(state, { componentName, controlName, isVisible }) {

      if (!state.componentControls[componentName]) {
        state.componentControls[componentName] = {}
      }
      Vue.set(state.componentControls[componentName], controlName, isVisible)
    },
    setComponentControls(state, { componentName, controls }) {
      state.componentControls[componentName] = controls
    },
  },
  getters: {
    getComponentControls: (state) => (componentName) => {
      return state.componentControls[componentName] || {}
    },
    isControlVisible: (state) => (componentName, controlName) => {
      const component = state.componentControls[componentName]
      if (!component) return true
      return component[controlName] !== false
    },
    
  }
})

export default store